import { defineStore } from 'pinia'
import Sleep from '@/models/sleep'

export const useSleepStore = defineStore('sleep', {
  state: () => ({
    // These are the aggregated score metrics which change depending on the
    // defined time period on the page.
    summary: {
      consistency: {
        score: undefined, // 0.56
        grade: undefined, // Poor, okay, optimal
        color: undefined, // Grade color
        text: undefined, // Explains the grade
        bedTimeAverage: undefined, // 22:30:00
        bedTimeRange: undefined, // 160 (mins)
        // wakeTimeAverage: undefined, // 07:30:00
        // wakeTimeRange: undefined, // 160 (mins)
      },
      duration: {
        score: undefined, // Average a percentage of target
        grade: undefined, // Poor, okay, optimal
        color: undefined, // Grade color
        text: undefined, // Explains the grade
        average: undefined,
        // range: undefined,
      },
      quality: {
        score: undefined,
        grade: undefined, // Poor, okay, optimal
        color: undefined, // Grade color
        text: undefined, // Explains the grade
        range: undefined,
      },
    },
    // TODO: Make this persistent across pages to optimise load times.
    sleeps: [], // Sleep object {id: 'X', date: '2024-05-21', duration: 120, consistency: 0.64, quality: 0.85, timeStart: Date(), timeEnd: Date() }
  }),
  getters: {
  },
  actions: {
    // Updates the summary data for the given date range (inclusive).
    // updateSummary(dateFrom, dateTo) {},
    updateConsistency(consistencyObject) {
      // TODO: Type check on consistency object (has `score`, `bedTimeAverage`, `bedTimeRange`).
      if (!consistencyObject) {
        return
      }
      this.summary.consistency = consistencyObject

      // Set grade for consistency score.
      switch (true) {
        case (this.summary.consistency.score >= 90):
          this.summary.consistency.grade = 'optimal'
          this.summary.consistency.color = 'teal'
          this.summary.consistency.text = 'Your bed and wake times are optimally consistent!'
          break
        case (this.summary.consistency.score >= 80):
          this.summary.consistency.grade = 'okay'
          this.summary.consistency.color = 'blue'
          this.summary.consistency.text = 'Your bed and wake times vary a little bit each day.'
          break
        default:
          this.summary.consistency.grade = 'poor'
          this.summary.consistency.color = 'orange'
          this.summary.consistency.text = 'Your bed and wake times vary a lot each day.'
    }
    },
    // Updates the duration summary data with the given object.
    updateDuration(durationObject) {
      // TODO: Type check on duration object (has `score`, `average`, `range`).
      if (!durationObject) {
        return
      }
      this.summary.duration = durationObject

      // Set grade for duration average.
      switch (true) {
        case (this.summary.duration.average >= 7*60):
          this.summary.duration.grade = 'optimal'
          this.summary.duration.color = 'teal'
          this.summary.duration.text = 'Your sleep duration is optimal!'
          break
        case (this.summary.duration.average >= 6*60):
          this.summary.duration.grade = 'okay'
          this.summary.duration.color = 'blue'
          this.summary.duration.text = 'Aim to get more then 7 hours of sleep.'
          break
        default:
          this.summary.duration.grade = 'poor'
          this.summary.duration.color = 'orange'
          this.summary.duration.text = 'Aim to get more than 6 hours of sleep.'
      }
    },
    updateQuality(qualityObject) {
      // TODO: Type check on quality object (has `score`, `range`).
      if (!qualityObject) {
        return
      }
      this.summary.quality = qualityObject

      switch (true) {
        case (this.summary.quality.score >= 0.85):
          this.summary.quality.grade = 'optimal'
          this.summary.quality.color = 'teal'
          this.summary.quality.text = 'Your sleep efficiency is optimal!'
          break
        case (this.summary.quality.score >= 0.80):
          this.summary.quality.grade = 'okay'
          this.summary.quality.color = 'blue'
          this.summary.quality.text = 'Aim for an optimimal level of 85% sleep efficiency.'
          break
        default:
          this.summary.quality.grade = 'poor'
          this.summary.quality.color = 'orange'
          this.summary.quality.text = 'Aim for a better level of 80% sleep efficiency.'
      }
    },
    // Updates the sleeps array by merging new data, where same date objects
    // are overwritten.
    update(sleeps) {
      // if (!(sleep instanceof Sleep)) {
      //   throw new Error('Update must be a Sleep object.')
      // }
      console.log('@/store/sleep.js: Updating sleep store.', sleeps, (sleeps instanceof Sleep))
      // this.streakObject = streak
    },
  },
})